import Vue from 'vue';
import VModal from 'vue-js-modal';
import VueCookieBot from '@ambitiondev/vue-cookiebot-plugin';

Vue.use(VModal);
Vue.use(VueCookieBot, {
  cookieBotID: process.env.APP_COOKIEBOT_ID
});

// Register Ald Automotive components, they start with 'ald-', example: ald-accordion
Vue.component('ald-button', () =>
  import(/* webpackChunkName: "components/ald-button" */ 'components/Button')
);
Vue.component('ald-expansion-panel', () =>
  import(/* webpackChunkName: "components/ald-expansion-panel" */ 'components/ExpansionPanel')
);
Vue.component('ald-icon', () =>
  import(/* webpackChunkName: "components/ald-icon" */ 'components/Icon')
);
Vue.component('ald-loader', () =>
  import(/* webpackChunkName: "components/ald-loader" */ 'components/Loader')
);
Vue.component('ald-markdown', () =>
  import(/* webpackChunkName: "components/ald-markdown" */ 'components/Markdown')
);
Vue.component('ald-modal', () =>
  import(/* webpackChunkName: "components/ald-modal" */ 'components/Modal')
);
Vue.component('ald-text', () =>
  import(/* webpackChunkName: "components/ald-text" */ 'components/Text')
);
Vue.component('ald-tab', () =>
  import(/* webpackChunkName: "components/ald-tab" */ 'components/Tabs/Tab')
);
Vue.component('ald-tabs', () =>
  import(/* webpackChunkName: "components/ald-tabs" */ 'components/Tabs')
);
Vue.component('ald-transition', () =>
  import(/* webpackChunkName: "components/ald-transition" */ 'components/Transition')
);
